let smallScreenCart = document.querySelector('.header__navigation__cart');
let largeScreenCart = document.querySelector('.header__interactive__cart');
let cartDrawer = document.querySelector('.header__cart');
let cartOverlay = document.querySelector('.header__cart__overlay');
let closeCartBtn = document.querySelector('.minicart__close')


Array.from([smallScreenCart, largeScreenCart]).forEach((cart) => {
    cart.addEventListener('click', function (e) {
        cartOverlay.classList.add('header__cart__overlay--active');
        cartDrawer.classList.add('header__cart--active')


    })
})

Array.from([closeCartBtn, cartOverlay]).forEach((close)=>{
    close.addEventListener('click', function (e) {
        cartOverlay.classList.remove('header__cart__overlay--active');
        cartDrawer.classList.remove('header__cart--active')
    })
})

